// extracted by mini-css-extract-plugin
export var card = "_8x-1";
export var container = "_8x-0";